import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import {
  NicheFilesCancelSubscriptionPayload,
  NicheFilesCreateCheckoutLinkPayload,
  NicheFilesCreateSubscriptionPayload,
  NicheFilesFetchCountyPricePayload,
  NicheFilesGetSubscriptionPayload,
  NicheFilesGetSubscriptionsPayload,
  NicheFilesRenewSubscriptionPayload,
} from "@containers/NicheFiles/interface";
import { NICHE_FILE_STATUS, NicheFilesSubscription } from "@shared/models";
import { NicheFilesFilter } from "@shared/interfaces";

export default {
  getNicheFilesPrice: (params: NicheFilesFetchCountyPricePayload): Promise<NicheFilesFetchCountyPricePayload[]> =>
    request(
      METHODS.GET,
      API.NICHE_FILES.GET_FILE_PRICE,
    )({
      params: {
        state_ids: params.join(","),
      },
    }),
  getNicheFilesSubscriptions: (params: NicheFilesGetSubscriptionsPayload): Promise<NicheFilesSubscription[]> =>
    request(METHODS.GET, API.NICHE_FILES.SUBSCRIPTIONS)({ params }),
  getNicheFilesSubscription: ({ id, ...params }: NicheFilesGetSubscriptionPayload): Promise<NicheFilesSubscription> =>
    request(METHODS.GET, API.NICHE_FILES.SUBSCRIPTION(id))({ params }),
  createNicheFilesSubscription: (params: NicheFilesCreateSubscriptionPayload): Promise<NicheFilesSubscription> =>
    request(METHODS.POST, API.NICHE_FILES.SUBSCRIPTIONS)(params),
  updateNicheFilesSubscription: ({
    id,
    ...params
  }: NicheFilesCreateSubscriptionPayload): Promise<NicheFilesSubscription> =>
    request(METHODS.PUT, API.NICHE_FILES.SUBSCRIPTION(id as string))(params),
  cancelNicheFilesSubscription: ({
    id,
    ...params
  }: NicheFilesCancelSubscriptionPayload): Promise<NicheFilesSubscription> =>
    request(METHODS.POST, API.NICHE_FILES.CANCEL_SUBSCRIPTION(id))(params),
  renewNicheFilesSubscription: ({
    id,
    ...params
  }: NicheFilesRenewSubscriptionPayload): Promise<NicheFilesSubscription> =>
    request(METHODS.POST, API.NICHE_FILES.RENEW_SUBSCRIPTION(id))(params),
  createCheckoutLink: ({ id, ...params }: NicheFilesCreateCheckoutLinkPayload): Promise<NicheFilesSubscription> =>
    request(METHODS.POST, API.NICHE_FILES.CREATE_CHECKOUT_LINK(id))(params),
  getNicheFiles: (payload: NicheFilesFilter) => request(METHODS.GET, API.NICHE_FILES.GET_FILES)({ params: payload }),
  getNicheFileSignedUrl: (fileId: number) => request(METHODS.GET, API.NICHE_FILES.GET_FILE_SIGNED_URL(fileId))(),
  getNicheFile: (fileId: number) => request(METHODS.GET, API.NICHE_FILES.GET_FILE(fileId))(),
  deleteNicheFile: (fileId: number) => request(METHODS.DELETE, API.NICHE_FILES.DELETE_FILE(fileId))(),
  updateNicheFileStatus: (payload: { id: number; status: NICHE_FILE_STATUS }) =>
    request(METHODS.PUT, API.NICHE_FILES.UPDATE_FILE_STATUS(payload.id))({ status: payload.status }),
};
